const l1ItemKey = Symbol('l1ItemKey');

type TL1ItemData = {
	menuItemId: string;
	label?: string;
	isHidden: boolean;
	isHideable: boolean;
	isReorderable: boolean;
	[l1ItemKey]: true;
};

export function getL1ItemData({
	menuItemId,
	label,
	isHidden,
	isHideable,
	isReorderable,
}: {
	menuItemId: string;
	label?: string;
	isHidden: boolean;
	isHideable: boolean;
	isReorderable: boolean;
}): TL1ItemData {
	return {
		menuItemId,
		label,
		isHidden,
		isHideable,
		isReorderable,
		[l1ItemKey]: true,
	};
}

export function isL1ItemData(data: Record<string | symbol, unknown>): data is TL1ItemData {
	return data[l1ItemKey] === true;
}
